import { render, staticRenderFns } from "./HighTechListMPT.vue?vue&type=template&id=6963154a&scoped=true"
import script from "./HighTechListMPT.vue?vue&type=script&lang=js"
export * from "./HighTechListMPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963154a",
  null
  
)

export default component.exports